"use client";
import NavbarSection from "@/components/HomeDynamic/sections/NavbarSection";
import Steps from "@/components/Home/Steps/Steps";
import MarketProducts from "@/components/Home/MarketProducts/MarketProducts";
import HowPadamiHelps from "@/components/Home/HowPadamiHelps/HowPadamiHelps";
import BusinessGrow from "@/components/Home/BusinessGrow/BusinessGrow";
import WriteLetter from "@/components/Home/WriteLetter/WriteLetter";
import ScrollStacking from "@/components/ScrollStacking/ScrollStacking";
import { useEffect } from "react";
import { Box, Button } from "@mui/material";
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { useRouter } from "next/navigation";
import HeroSection from "@/components/HomeDynamic/sections/HeroSection";
import FooterSection from "@/components/HomeDynamic/sections/FooterSection";
import homeDynamicConfig from '@/public/homeDynamicConfig.json';
import themeConfig from '@/public/themeConfig.json';
import navbarConfig from '@/public/navbarConfig.json';

export default function Home() {

  const router = useRouter();
  useEffect(() => {
    const sections = document.querySelectorAll("div[id]");

    if (sections.length === 0) return;

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.6,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          if (id) {
            try {
              window.history.replaceState(null, "", `#${id}`);
            } catch (error) {
              // Silently handle history errors
              console.warn('History update failed:', error);
            }
          }
        }
      });
    }, options);

    sections.forEach((section) => {
      if (section && section.id) {
        try {
          observer.observe(section);
        } catch (error) {
          console.warn('Failed to observe section:', error);
        }
      }
    });

    return () => {
      sections.forEach((section) => {
        if (section) {
          try {
            observer.unobserve(section);
          } catch (error) {
            // Silently handle cleanup errors
          }
        }
      });
    };
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id.slice(1));
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
    
      <NavbarSection 
        config={navbarConfig.navbarConfig} 
        theme={{ ...themeConfig.themeConfig, variant: 'default' }} 
        sticky={false}
      />

      <ScrollStacking
        direction="vertical"
        className="main-stacking"
        sectionDirections={{
          testimonial: "horizontal",
        }}
      >

        <div className="stacking-item" id="overview">
          <HeroSection 
            config={{
              ...homeDynamicConfig.homeDynamicConfig.heroSectionConfig,
              title: "Augmented Reality Photo Frames & Albums",
              subtitle: "for Next-Gen Businesses",
              buttonText: "Check Pricing"
            }}
            theme={{ ...themeConfig.themeConfig, variant: 'default' }}
          />
        </div>
        <div className="stacking-item" id="business-grow">
          <BusinessGrow />
        </div>
        <div className="stacking-item" id="steps">
          <Steps />
        </div>
        <div className="stacking-item" id="trending">
          <MarketProducts />
        </div>
        <div className="stacking-item" id="how-helps">
          <HowPadamiHelps />
        </div>
        <div className="stacking-item" id="testimonial">
          <WriteLetter />
        </div>
      </ScrollStacking>
      {/* Floating Product Button */}
      <Box
        sx={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          zIndex: 1000,
          '@media (max-width: 768px)': {
            bottom: '20px',
            right: '20px',
          },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "flex-end" }}>
          <Button
            variant="contained"
            startIcon={<ShoppingBagIcon />}
            onClick={() => {
              if (typeof window !== "undefined") {
                window.location.href = "/products";
              }
            }}
            className="btn-theme-one"
          >
            View Product
          </Button>

          <Button
            variant="contained"
            onClick={() => {
              if (typeof window !== "undefined") {
                window.location.href = "/order/demo-order-1/upload-video";
              }
            }}
            className="btn-theme-one"
          >
            Upload Magic Video
          </Button>
        </Box>
      </Box>
      <FooterSection 
        config={homeDynamicConfig.homeDynamicConfig.footerConfig} 
        navbarConfig={navbarConfig.navbarConfig} 
        theme={{ ...themeConfig.themeConfig, variant: 'default' }} 
      />
    </>
  );
}
